export const EAGER_MODULES = [];